export class AccountUserNotFound extends Error {
  public constructor() {
    super()

    this.message = 'errors.accountUserNotFound'
  }
}
